import { DestroyRef, Injectable, ViewContainerRef, inject } from '@angular/core';
import { IActionGroup, IActionHandler, IActionHandlerFactory } from '../interfaces';
import { LinkingActionHandler } from './linking-action-handler';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { ActionCenterLinkerFactory } from '../actions/linking/factory';
import { SmartSuggestActionHandler } from './smart-suggest-action-handler';
import { AiSuggestionsFactory } from '../actions/ai-suggest/factory';
import { DeletionActionHandler } from './deletion-action-handler';
import { DeleterFactory } from '../actions/deletion/factory';
import { AuDialogService } from '@app/core/services/au-dialog.service';
import { TranslateService } from '@tolgee/ngx';

@Injectable({
	providedIn: 'root',
})
export class ActionHandlerFactory implements IActionHandlerFactory {
	private readonly actionCenterService = inject(ActionCenterService);
	private readonly dialogService = inject(AuDialogService);

	private readonly linkerFactory = inject(ActionCenterLinkerFactory);
	private readonly AiSuggestionsFactory = inject(AiSuggestionsFactory);
	private readonly deleterFactory = inject(DeleterFactory);
	private readonly translateService = inject(TranslateService);

	private viewContainerRef: ViewContainerRef;
	private destroyRef: DestroyRef;

	addDeps(viewContainerRef: ViewContainerRef, destroyRef: DestroyRef): void {
		this.viewContainerRef = viewContainerRef;
		this.destroyRef = destroyRef;
	}
	createHandler(actionGroup: IActionGroup): IActionHandler {
		if (actionGroup === 'linking') {
			return new LinkingActionHandler(
				this.actionCenterService,
				this.viewContainerRef,
				this.linkerFactory,
				this.destroyRef
			);
		}
		if (actionGroup === 'ai-suggestions') {
			return new SmartSuggestActionHandler(
				this.actionCenterService,
				this.viewContainerRef,
				this.AiSuggestionsFactory,
				this.destroyRef
			);
		}
		if (actionGroup === 'delete') {
			return new DeletionActionHandler(
				this.actionCenterService,
				this.deleterFactory,
				this.dialogService,
				this.translateService
			);
		}
	}
}
